@let canModifyThemeValue = canModifyTheme();

<button
  type="button"
  class="profile-menu__labels"
  panelHasPopup="menu"
  [kdsPanelTrigger]="panel"
  [verticalMargin]="0"
  [kdsTooltip]="'header.tooltips.my-account' | translate"
  [disableTooltip]="false"
  [showTooltipOnlyOnDesktop]="true"
  [attr.aria-label]="'header.tooltips.my-account' | translate"
  [class.profile-menu__labels--active]="isPanelOpened"
  (changePanelVisibility)="isPanelOpened = $event"
>
  <kds-avatar size="small" variant="image" [firstName]="userFirstName()" [lastName]="userLastName()" />
  <span class="profile-menu__labels-full-name">{{ userFullName() }}</span>
</button>

<ng-template #panel>
  <div kdsMenuKeyboardNavigation class="profile-menu__items" role="menu" [attr.aria-label]="'header.tooltips.my-account' | translate">
    <itc-profile-info />
    <div class="profile-menu__divider" role="separator"></div>
    <a
      role="menuitem"
      class="profile-menu__item"
      kdsPrefetch
      [routerLink]="userSettingsTopNavigationItem.id"
      (click)="setUserSettingsTopNavigation()"
    >
      <i class="profile-menu__item-icon {{ userSettingsTopNavigationItem.iconClass }}" aria-hidden="true"></i>
      <div class="profile-menu__item-text">{{ 'profile-menu.my-settings' | translate }}</div>
    </a>
    <button
      *itcPermission="Permission.ThemeSettingsView"
      type="button"
      role="menuitem"
      class="profile-menu__item"
      panelHasPopup="menu"
      [class.profile-menu__item--active]="isThemePanelOpened"
      [class.profile-menu__item--readonly]="!canModifyThemeValue"
      [attr.aria-disabled]="!canModifyThemeValue"
      [kdsTooltip]="'general.missing-permission' | translate"
      [disableTooltip]="canModifyThemeValue"
      [kdsPanelTrigger]="themePanel"
      [panelTriggerDisabled]="!canModifyThemeValue"
      [keepOthersOpen]="true"
      [openSide]="'left'"
      [closeOnContentClick]="false"
      [verticalMargin]="0"
      [horizontalMargin]="1"
      (click)="$event.stopPropagation()"
      (changePanelVisibility)="isThemePanelOpened = $event"
    >
      <i aria-hidden="true" class="profile-menu__item-icon fa-regular fa-circle-half-stroke"></i>
      <div class="profile-menu__item-text">{{ 'profile-menu.theme' | translate }}</div>
      <i aria-hidden="true" class="profile-menu__item-chevron fa-regular fa-chevron-right"></i>
    </button>
    <div class="profile-menu__divider" role="separator"></div>
    <a role="menuitem" class="profile-menu__item" kdsPrefetch [routerLink]="ApplicationPath.Logout">
      <i aria-hidden="true" class="profile-menu__item-icon fa-regular fa-arrow-right-from-bracket"></i>
      <div class="profile-menu__item-text">{{ 'profile-menu.log-out' | translate }}</div>
    </a>
  </div>
</ng-template>

<ng-template #themePanel>
  <itc-theme-options-list />
</ng-template>
